import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';


@Component({
  selector:'app-merchant-service-edit',
  templateUrl:'./merchant-service-edit.component.html',
  styleUrls:['./merchant-service-edit.component.scss']
})
export class MerchantServiceEditComponent implements OnInit {


serviceForm!:FormGroup;


serviceId:any;
merchantData:any;

categories:any[]=[];
merchantId:any;



// media

selectedFiles:any[]=[];

previewFiles:any[]=[];



// locations

locations:string[]=[];

locationInput:string="";



// payment

paymentType:string="FULL_PAYMENT";

advanceAmount:number=0;




imageBaseUrl =
environment.apiUrl.replace('/api/v1.0','');





constructor(
private fb:FormBuilder,
private apiService:ApiServiceService,
private route:ActivatedRoute,
private router:Router
){}





ngOnInit(){


this.serviceId =
this.route.snapshot.paramMap.get('id');

const userStr = localStorage.getItem('user');
if (userStr) {
  this.merchantData = JSON.parse(userStr);
}

this.merchantId =
localStorage.getItem('merchantId');



this.createForm();




this.getCategories();
this.loadService();


}





createForm(){


this.serviceForm =
this.fb.group({


service_name:[
'',
Validators.required
],


category:[
'',
Validators.required
],


description:[
''
],


price:[
'',
Validators.required
],


duration:[
''
],


included:[
''
]


});


}






loadService(){



this.apiService
.getMerchantServices(this.merchantId)
.subscribe({


next:(res:any)=>{


const service =
res.data.find(
(x:any)=>x._id===this.serviceId
);



if(service){


this.serviceForm.patchValue({


service_name:
service.service_name,


category:
service.category?._id,


description:
service.description,


price:
service.price,


duration:
service.duration,


included:
service.included?.join(',')


});





this.locations =
service.service_locations || [];





if(service.payment){


this.paymentType =
service.payment.type;


this.advanceAmount =
service.payment.advanceAmount || 0;


}





if(service.media && service.media.length > 0){
this.previewFiles =
[service.media[0]].map((m:any)=>({


url:
this.imageBaseUrl+m.media_url,


type:
m.media_type


}));


}



}



},


error:(err)=>{


console.log(err);


}



});


}









selectFiles(event:any){
const file = event.target.files[0];
if(file){
  this.selectedFiles = [file];
  const reader = new FileReader();
  reader.onload=(e:any)=>{
    this.previewFiles = [{
      url:e.target.result,
      type: 'image'
    }];
  };
  reader.readAsDataURL(file);
}
}







removeFile(index:number){


this.previewFiles.splice(
index,
1
);


if(index < this.selectedFiles.length){

this.selectedFiles.splice(
index,
1
);

}


}









addLocation(){


if(this.locationInput.trim()){


this.locations.push(
this.locationInput.trim()
);


this.locationInput="";


}


}






removeLocation(index:number){


this.locations.splice(
index,
1
);


}






paymentChanged(){


if(this.paymentType!=="ADVANCE"){


this.advanceAmount=0;


}


}









updateService(){



const formData =
new FormData();




formData.append(
'service_name',
this.serviceForm.value.service_name
);



formData.append(
'category',
this.serviceForm.value.category
);



formData.append(
'description',
this.serviceForm.value.description
);



formData.append(
'price',
this.serviceForm.value.price
);



formData.append(
'duration',
this.serviceForm.value.duration
);





const included =
this.serviceForm.value.included
?
this.serviceForm.value.included
.split(',')
.map((x:string)=>x.trim())
.filter((x:string)=>x)
:
[];




formData.append(
'included',
JSON.stringify(included)
);





formData.append(

'service_locations',

JSON.stringify(this.locations)

);






formData.append(

'payment',

JSON.stringify({

type:this.paymentType,

advanceAmount:this.advanceAmount

})

);






this.selectedFiles.forEach(file=>{


formData.append(
'media',
file
);


});







this.apiService
.updateMerchantService(
this.serviceId,
formData
)
.subscribe({



next:()=>{


Swal.fire({

icon:'success',

title:'Updated',

timer:1500,

showConfirmButton:false

});



this.router.navigate([

'/merchant/services'

]);


},



error:(err)=>{


console.log(err);


}



});





}








goBack(){


this.router.navigate([

'/merchant/services'

]);


}
getCategories(){

this.apiService
.getServiceCategories()
.subscribe({

next:(res:any)=>{

this.categories =
res.data || [];

},

error:(err)=>{

console.log(err);

}

});

}



}